/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Error_GenericInputs */

const en_directory_ai_tools_error_generic = /** @type {(inputs: Directory_Ai_Tools_Error_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong. If credits were charged for a failed render, they are refunded automatically.`)
};

const zh_directory_ai_tools_error_generic = /** @type {(inputs: Directory_Ai_Tools_Error_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出了点问题。如果失败的生成扣了积分，会自动退还。`)
};

/**
* | output |
* | --- |
* | "Something went wrong. If credits were charged for a failed render, they are refunded automatically." |
*
* @param {Directory_Ai_Tools_Error_GenericInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_error_generic = /** @type {((inputs?: Directory_Ai_Tools_Error_GenericInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Error_GenericInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_error_generic(inputs)
	return zh_directory_ai_tools_error_generic(inputs)
});
export { directory_ai_tools_error_generic as "directory.ai_tools.error.generic" }